export default "__VITE_ASSET__cc9ddbd9__"